import { DEBUG_MODE, server } from "./Config.js"

export const debug_mode = DEBUG_MODE;

export const annoBisestile = (year) => {
    if (year % 4 === 0) {
        if (year % 100 === 0) {
            if (year % 400 === 0) {
                return true; // Divisibile per 400
            } else {
                return false; // Divisibile per 100 ma non per 400
            }
        } else {
            return true; // Divisibile per 4 ma non per 100
        }
    } else {
        return false; // Non divisibile per 4
    }
}

export const calcola_diff_giorni = (data_oggi, data1, data2) => {
    if (data1 === "oggi") {
        data1 = data_oggi;
    } else {
        data1 = new Date(data1.split("/")[2], parseInt(data1.split("/")[1]) - 1, data1.split("/")[0]);
    }
    if (data2 === "oggi") {
        data2 = data_oggi;
    } else {
        data2 = new Date(data2.split("/")[2], parseInt(data2.split("/")[1]) - 1, data2.split("/")[0]);
    }
    let diffTime = data2 - data1;
    var diffGiorni = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffGiorni
}

export const refreshAccessToken = async () => {
    let new_token = "";

    const refreshToken = localStorage.getItem("refresh_token");
    if (!refreshToken) return;

    try {
        const data = await fetchWithoutAuth("refresh_token.php", {
            body: JSON.stringify({ refresh_token: refreshToken })
        });

        if (data.ok) {
            localStorage.setItem("access_token", data.access_token);
            new_token = data.access_token;
        } else {
            // Refresh non valido: rimuovi token
            localStorage.clear();
            console.warn("Refresh token invalid:", data.error);
        }
    } catch (error) {
        console.error("Errore refresh token:", error);
        localStorage.clear();
    }
    return new_token;
}

// Funzione per le fetch con auth
export const fetchWithAuth = async (url, options = {}, method = "POST") => {
    let token = localStorage.getItem("access_token");

    if (!token || token == undefined || token == "undefined") {
        localStorage.clear();
        sessionStorage.clear();

        throw new Error("Non autenticato");
    }

    const defaultOptions = {
        method,
        headers: {
            "Content-Type": "application/json",
            ...options.headers
        },
        ...options
    };

    const doFetch = async (currentToken) => {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), server.timeout);

        try {
            const response = await fetch(server.url + url, {
                ...defaultOptions,
                headers: {
                    ...defaultOptions.headers,
                    "Authorization": currentToken ? `Bearer ${currentToken}` : ""
                },
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            if (response.status === 401) {
                return { unauthorized: true };
            }

            const data = await response.json();
            return data;

        } catch (error) {
            clearTimeout(timeoutId);
            if (error.name === 'AbortError') throw new Error("Timeout della richiesta");
            throw error;
        }
    };
    // Prima fetch
    let result = await doFetch(token);

    // Se 401, prova a fare refresh e ripetere
    if (result?.unauthorized) {
        const newToken = await refreshAccessToken();
        if (newToken) {
            token = newToken;
            result = await doFetch(token);
        } else {
            // Refresh fallito: forza logout
            alert("Sessione scaduta, accedi nuovamente.");
            localStorage.clear();
            window.location.href = "/login";
            throw new Error("Sessione scaduta");
        }
    }

    return result;
};

// Funzione per login senza token
export const fetchWithoutAuth = async (url, options = {}, method = "POST") => {
    const defaultOptions = {
        method,
        headers: {
            "Content-Type": "application/json",
            ...options.headers
        },
        ...options
    };

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), server.timeout);

    try {
        const response = await fetch(server.url + url, {
            ...defaultOptions,
            signal: controller.signal
        });

        if (debug_mode) console.log(response)

        clearTimeout(timeoutId);

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        if (error.name === 'AbortError') {
            throw new Error("Timeout della richiesta");
        }
        console.error("Fetch error:", error);
        throw error;
    }
};

// Funzione per verificare se l'utente è loggato
export const isLoggedIn = () => {
    const token = localStorage.getItem("access_token");
    return !!token;
};

// Funzione per ottenere il token
export const getToken = () => {
    return localStorage.getItem("access_token");
};

// Funzione per salvare il token
export const saveToken = (token) => {
    localStorage.setItem("access_token", token);
};

// Funzione per rimuovere il token
export const removeToken = () => {
    localStorage.removeItem("access_token");
};

export const parseData = (dataStr) => {
    if (!dataStr) return null;

    // Splitta la data
    const [giorno, mese, anno] = dataStr.split("/").map(Number);

    return new Date(anno, mese - 1, giorno);
}

export const normalizeDate = (input) => {
    if (typeof input !== 'string') return null;

    input = input.trim();

    let day, month, year;

    // yyyy-mm-dd o yyyy/mm/dd
    let match1 = input.match(/^(\d{4})[-\/](\d{2})[-\/](\d{2})$/);
    if (match1) {
        year = match1[1];
        month = match1[2];
        day = match1[3];
    } else {
        // d/m/yyyy, dd/m/yyyy, d/mm/yyyy, dd/mm/yyyy
        let match2 = input.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/);
        if (match2) {
            day = match2[1].padStart(2, '0');
            month = match2[2].padStart(2, '0');
            year = match2[3];
        } else {
            return null; // formato non valido
        }
    }

    return `${year}-${month}-${day}`;
}